import React from 'react';

const sizeClasses = {
  small: 'h-8 w-8',
  medium: 'h-12 w-12',
  large: 'h-16 w-16'
};

const SkullLoader = ({ size = 'medium', label = 'Loading' }) => {
  const sizeClass = sizeClasses[size] || sizeClasses.medium;

  return (
    <div className="flex items-center justify-center" role="status" aria-label={label}>
      <span className={`skull-loader ${sizeClass}`} aria-hidden="true">
        <svg className="skull-loader__ring" viewBox="0 0 48 48" fill="none">
          <path d="M24 3a21 21 0 0 1 19.1 12.3" />
          <path d="M43.1 32.7a21 21 0 0 1 -19.1 12.3" />
          <path d="M4.9 32.7a21 21 0 0 1 0 -17.4" />
        </svg>
        <svg
          className="skull-loader__skull"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 4c4.418 0 8 3.358 8 7.5c0 1.901 -.755 3.637 -2 4.96l0 2.54a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-2.54c-1.245 -1.322 -2 -3.058 -2 -4.96c0 -4.142 3.582 -7.5 8 -7.5" />
          <path d="M10 17v3" />
          <path d="M14 17v3" />
          <path d="M8 11a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
          <path d="M14 11a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
        </svg>
      </span>
      <span className="sr-only">{label}</span>
    </div>
  );
};

export default SkullLoader;
